import { getReturnListRequest, } from '@/assets/request/SaleRequest'
import {Message} from "element-ui";
import { RETURN_TYPE_ARR, RETURN_STATUS_ARR, } from '../../assets/result/saleResult'
export default {
  state: {
    list: [],
    page: 1,
    page_size: 10,
    totalCount: 0,
    pageTotal: 0,
    searchData: {
      return_id: null,
      return_sn: null,
      plate_number: null,
      vin: null,
      brand_name: null,
      inquiry_id: null,
      order_sn: null,
      order_type: null,
      return_type: null,
      return_status: null,
      start_time: null,
      end_time: null,
    },
  },
  mutations: {
    dealerBackListChangeObj(state,obj){
      Object.entries(obj).forEach(item=>{
        state[item[0]] = item[1]
      })
    },
  },
  actions: {
    dealerBackListAction(context){
      const { state, commit, } = context
      const { page, page_size, searchData, } = state
      getReturnListRequest({
        page,
        page_size,
        ...searchData
      }).then(r=>{
        if(r.status!==200) return Message.warning(r.statusText)
        const { code, msg, data, } = r.data
        if(Number(code)!==200) return Message.warning(msg)
        const { list, page, page_size, total_num, total_page, } = data
        commit('dealerBackListChangeObj',{
          list: list.map(i=>({
            ...i,
            return_typeText: RETURN_TYPE_ARR.filter(iArr=>Number(iArr.value)===Number(i.return_type)).reduce((total,item)=>{
              total+=item.cn_name
              return total
            },''),
            return_statusText: RETURN_STATUS_ARR.filter(iArr=>Number(iArr.value)===Number(i.return_status)).reduce((total,item)=>{
              total+=item.cn_name
              return total
            },''),
          })),
          ...[
            ['page',page,],
            ['page_size',page_size,],
            ['totalCount',total_num,],
            ['pageTotal',total_page,],
          ].map(i=>([
            i[0],
            Number(i[1]),
          ])).reduce((total,item)=>{
            total[item[0]] = item[1]
            return total
          },{})
        })
      })
    },
  },
  getters: {
    dealerBackListAllGetter: state => state,
  },
}